import { useCallback, useState } from 'react'

import type { TableState } from './types'

export const defaultTableState: TableState = {
  search: '',
  filters: {},
  sortKey: null,
  sortDir: 'asc',
  page: 1,
  pageSize: 10,
}

/**
 * Local table state. Only useState — no routing, so this stays inside the
 * portable package. The URL-syncing variant lives in the app.
 */
export function useTableState(initial?: Partial<TableState>) {
  const [state, setRaw] = useState<TableState>({ ...defaultTableState, ...initial })

  const setState = useCallback((patch: Partial<TableState>) => {
    setRaw((previous) => {
      const next = { ...previous, ...patch }
      // Narrowing the result set while on page 7 strands the user on an empty
      // page, so anything but an explicit page change sends them back to 1.
      const narrowed =
        patch.search !== undefined || patch.filters !== undefined || patch.pageSize !== undefined
      if (patch.page === undefined && narrowed) next.page = 1
      return next
    })
  }, [])

  return { state, setState }
}

export type SetTableState = (patch: Partial<TableState>) => void
